export default "<p>report-payment-list works!</p>\r\n";